// Pipe Types
export const PIPE_TYPES = {
  CROSS: "cross",
  ELBOW_BOTTOM_LEFT: "elbow_bottom_left",
  ELBOW_BOTTOM_RIGHT: "elbow_bottom_right",
  ELBOW_LEFT_TOP: "elbow_left_top",
  ELBOW_TOP_RIGHT: "elbow_top_right",
  STRAIGHT_HORIZONTAL: "straight_horizontal",
  STRAIGHT_VERTICAL: "straight_vertical",
  T_DOWN: "t_down",
  T_LEFT: "t_left",
  T_RIGHT: "t_right",
  T_UP: "t_up",
  END_BOTTOM: "end_bottom",
  END_LEFT: "end_left",
  END_RIGHT: "end_right",
  END_TOP: "end_top",
};

// Connection points for each pipe type
export const PIPE_CONNECTIONS = {
  [PIPE_TYPES.CROSS]: ["top", "right", "bottom", "left"],
  [PIPE_TYPES.ELBOW_BOTTOM_LEFT]: ["bottom", "left"],
  [PIPE_TYPES.ELBOW_BOTTOM_RIGHT]: ["bottom", "right"],
  [PIPE_TYPES.ELBOW_LEFT_TOP]: ["left", "top"],
  [PIPE_TYPES.ELBOW_TOP_RIGHT]: ["top", "right"],
  [PIPE_TYPES.STRAIGHT_HORIZONTAL]: ["left", "right"],
  [PIPE_TYPES.STRAIGHT_VERTICAL]: ["top", "bottom"],
  [PIPE_TYPES.T_DOWN]: ["left", "right", "bottom"],
  [PIPE_TYPES.T_LEFT]: ["top", "bottom", "left"],
  [PIPE_TYPES.T_RIGHT]: ["top", "bottom", "right"],
  [PIPE_TYPES.T_UP]: ["left", "right", "top"],
  [PIPE_TYPES.END_BOTTOM]: ["bottom"],
  [PIPE_TYPES.END_LEFT]: ["left"],
  [PIPE_TYPES.END_RIGHT]: ["right"],
  [PIPE_TYPES.END_TOP]: ["top"],
};

// Grid Constants
export const GRID_SIZE = 4;

// Colors
export const COLORS = {
  pipe: {
    name: "pipe",
    main: "#A5D6F2", // Light blue for pipes
    outline: "#000000",
    junction: "#FF0000", // Red for junctions
    endpoint: "#A5D6F2", // Light blue for endpoints
  },
};

// Direction mappings
export const DIRECTIONS = {
  UP: "up",
  RIGHT: "right",
  DOWN: "down",
  LEFT: "left",
};

// Rotation mappings
export const ROTATIONS = {
  0: { up: "up", right: "right", down: "down", left: "left" },
  90: { up: "right", right: "down", down: "left", left: "up" },
  180: { up: "down", right: "left", down: "up", left: "right" },
  270: { up: "left", right: "up", down: "right", left: "down" },
};
